import "./styles.module.scss";
import "../utils/slick/slick.scss";
import "../utils/slick/slick-theme.scss";

import { graphql } from "gatsby";
import React from "react";

import LayoutV2 from "../components/Layout/LayoutV2";
import HeroSection from "../components/HeroSection";
import ArticlesCarousel from "../components/ArticlesCarousel";
import FAQSection from "../components/FAQSection";
import { PhotoCards } from "../components/PhotoCards";

const HomePage = ({ data }) => {
  return (
    <LayoutV2>
      <HeroSection articles={data.guideNodeMain.articleGroups} />
      <ArticlesCarousel data={data} />
      <FAQSection />
      <PhotoCards />
    </LayoutV2>
  );
};

export default HomePage;

export const query = graphql`
  query Home {
    guideNodeMain(id: { eq: "guide main" }) {
      articleGroups {
        groupTitle
        guideDocs {
          uri
          contents
          groupId
          guideTitle
        }
        id
      }
    }
  }
`;
